import React, { useState, useEffect } from 'react';
import { Container, Col, Row } from 'reactstrap';
import { DashBoardTitle } from '../../../Components/Title';
import './index.css';
import {
  addCommitment,
  addCompetition,
  editCommitment,
  editCompetitionInsights,
  getProducts,
  yearlyKYC,
} from '../../../constants/apiCalls';
import { useNavigate, useLocation } from 'react-router-dom';
import swal from 'sweetalert';
import ModalService from '../../../services/ModalService';
import CustomSpinner from '../../../Components/CustomSpinner/CustomSpinner';
import { BreadCrumbBackButton } from '../../../Components/Breadcrumbs/BreadCrumbBackButton';
import { Breadcrumbs } from '../../../Components/Breadcrumbs/Breadcrumbs';
import { AddUserButton, CommonButton, CommonCommitment, CommonCompetition } from '../../../Components/CommonComponents';
import FYearService from '../../../services/FYearService';
import { CommitmentModal, CompanyModal, SegmentModal } from '../../../Components/CustomModal';
import { handleErrorMessage } from '../../../utils/utils';
import { useDispatch, useSelector } from 'react-redux';
import { dealerInfoAction } from '../../../reducers/DealerReducer';
import AppHeader from '../../../Layout/AppHeader';
import AppSidebar from '../../../Layout/AppSidebar';

const KYC = () => {
  let fYYear = FYearService.getFYear();
  let location = useLocation();
  const navigate = useNavigate();
  let stringArr = location.pathname.split(/(\d+)/);
  let userId = stringArr[1];

  const [isLoading, setIsloading] = useState(false);
  const [isModalLoading, setIsModalLoading] = useState(false);
  const [isBtnDisabled, setIsBtnDisabled] = useState('');

  const [productId, setProductId] = useState('');
  const [product, setProduct] = useState('');
  const [unitType, setUnitType] = useState('');
  const [productUnit, setProductUnit] = useState('');

  // Commitment
  const [editCommitmentId, setEditCommitmentId] = useState('');
  const [commitment, setCommitment] = useState('');
  const [secondYearcommitment, setSecondYearCommitment] = useState('');
  const [thirdYearcommitment, setThirdYearCommitment] = useState('');
  const [commitmentModal, setCommitmentModal] = useState(false);

  // Competition segment
  const [segmentData, setSegmentData] = useState([]);
  const [editSegmentId, setEditSegmentId] = useState('');
  const [segmentYear, setSegmentYear] = useState('');
  const [segmentName, setSegmentName] = useState('');
  const [segmentTurnOver, setSegmentTurnOver] = useState('');
  const [totalSegmentTurnOver, setTotalSegmentTurnOver] = useState('');
  const [segmentModal, setSegmentModal] = useState(false);

  // Competition company
  const [companyData, setCompanyData] = useState([]);
  const [editCompanyId, setEditCompanyId] = useState('');
  const [companyYear, setCompanyYear] = useState('');
  const [companyName, setCompanyName] = useState('');
  const [companyTurnOver, setCompanyTurnOver] = useState('');
  const [totalCompanyTurnOver, setTotalCompanyTurnOver] = useState('');
  const [companyModal, setCompanyModal] = useState(false);

  const [commitObj, setCommitObj] = useState({});

  const dispatch = useDispatch();
  const { dealerObj } = useSelector(state => state.DealerReducer);

  useEffect(() => {
    if (userId) {
      // getCommitments(userId);
      setIsloading(true);
      dispatch(dealerInfoAction(parseInt(userId), setIsloading));
    }
    getProductsDetail();
  }, []);

  useEffect(() => {
    const segment = dealerObj.segment_wise_business_competition || [];
    const company = dealerObj.company_wise_business_competition || [];
    let prevYearDataSegment = segment && segment.length > 0 ? segment.filter(val => val.year === fYYear.prevFinancialYear) : [];
    let prevYearDataCompany = company && company.length > 0 ? company.filter(val => val.year === fYYear.prevFinancialYear) : [];
    let totalSegmntTurnOver = prevYearDataSegment && prevYearDataSegment.length > 0 ? prevYearDataSegment.map(val => val.turnover) : [];
    let totalCompnyTurnOver = prevYearDataCompany && prevYearDataCompany.length > 0 ? prevYearDataCompany.map(val => val.turnover) : [];
    setTotalCompanyTurnOver(totalCompnyTurnOver);
    setTotalSegmentTurnOver(totalSegmntTurnOver);
    setCompanyData(prevYearDataCompany);
    setSegmentData(prevYearDataSegment);
  }, [dealerObj])

  useEffect(() => {
    getCommitData();
  }, [])

  useEffect(() => {
    let btnDisabled =
      commitObj && commitObj.commitmentData && commitObj.commitmentData.length > 0 &&
      companyData.length > 2 &&
      segmentData.length > 4;
    setIsBtnDisabled(btnDisabled);
  }, [commitObj, companyData, segmentData])

  const getCommitData = (obj) => {
    if (obj) {
      setCommitObj(obj);
    }
  }

  const getProductsDetail = () => {
    getProducts((res) => {
      const { data, success, error } = res;
      if (success === true) {
        setProduct(data);
      } else if (success === false || success === 'undefined') {
        ModalService.openAlert('', handleErrorMessage(error[0].message), 'error');
      }
    });
  };

  const handleProduct = (e, key) => {
    let val = e.target.value;
    if (key === 1) {
      setProductId(val);
      let value = product.filter((vals) => vals.id === +val);
      setUnitType(value[0].unit_type);
      setProductUnit(value[0].product_unit);
    } else if (key === 2) {
      setCommitment(val);
    } else if (key === 3) {
      setSecondYearCommitment(val);
    } else if (key === 4) {
      setThirdYearCommitment(val);
    }
  };

  // Commitment Starts
  const handleAddCommitment = (e, key) => {
    setCommitmentModal(!commitmentModal);
    setCommitment('');
    setSecondYearCommitment('');
    setThirdYearCommitment('');
    setProductId('');
    setUnitType('');
    setProductUnit('');
    setEditCommitmentId('');
  };

  const handleEditCommitment = (val, key) => {
    setProductId(val.product_id);
    setCommitment(val.commitments_new[0].first_year_commitment);
    setSecondYearCommitment(val.commitments_new[1].second_year_commitment);
    setThirdYearCommitment(val.commitments_new[2].third_year_commitment);
    setUnitType(val.unit_type);
    setProductUnit(val.product_unit);
    setEditCommitmentId(val.uuid);
    setCommitmentModal(!commitmentModal);
  };

  const handleSubmitCommmitment = (e) => {
    e.preventDefault();
    let filteredUnitType = product.filter((vals) => vals.id === +productId);
    let filteredUnitprice = filteredUnitType[0].unit_price;
    let total =
      parseFloat(commitment) +
      parseFloat(secondYearcommitment) +
      parseFloat(thirdYearcommitment);
    let totalPrice =
      filteredUnitprice * commitment +
      filteredUnitprice * secondYearcommitment +
      filteredUnitprice * thirdYearcommitment;
    let payload = {
      user_id: userId,
      product_id: parseInt(productId),
      unit_type: filteredUnitType[0].unit_type,
      total: parseFloat(total),
      commitments: [
        { first_year_commitment: parseFloat(commitment) },
        { second_year_commitment: parseFloat(secondYearcommitment) },
        { third_year_commitment: parseFloat(thirdYearcommitment) },
      ],
      commitment_prices: [
        {
          first_year_commitment_price: filteredUnitprice * commitment,
        },
        {
          second_year_commitment_price:
            filteredUnitprice * secondYearcommitment,
        },
        {
          third_year_commitment_price: filteredUnitprice * thirdYearcommitment,
        },
      ],
      total_price: totalPrice,
    };

    if (payload.user_id && !editCommitmentId) {
      addCommitment((res) => {
        const { message, success, error } = res;
        if (success === true) {
          ModalService.openAlert('', message, 'success');
          setCommitmentModal(!commitmentModal);
          commitObj && commitObj.getCommitments && commitObj.getCommitments();
          dispatch(dealerInfoAction(parseInt(userId), setIsloading));
        } else if (success === false || success === 'undefined') {
          if (error.length > 0) {
            ModalService.openAlert('', handleErrorMessage(error[0].message), 'error');
          } else {
            if (message === 'Failed to fetch') {
              ModalService.openAlert(
                '',
                'Oops, something went wrong check you internet connection and try again later',
                'error'
              );
            }
          }
        }
        setIsloading(false);
        setIsModalLoading(false);
      }, payload);
    }

    if (editCommitmentId) {
      let editpayload = {
        uuid: editCommitmentId,
        product_id: parseInt(productId),
        unit_type: unitType,
        total: parseFloat(total),
        commitments: [
          { first_year_commitment: parseFloat(commitment) },
          { second_year_commitment: parseFloat(secondYearcommitment) },
          { third_year_commitment: parseFloat(thirdYearcommitment) },
        ],
        commitment_prices: [
          {
            first_year_commitment_price: filteredUnitprice * commitment,
          },
          {
            second_year_commitment_price:
              filteredUnitprice * secondYearcommitment,
          },
          {
            third_year_commitment_price:
              filteredUnitprice * thirdYearcommitment,
          },
        ],
        total_price: totalPrice,
      };
      setIsloading(false);
      setIsModalLoading(true);
      editCommitment((res) => {
        const { message, success, error } = res;
        if (success === true) {
          ModalService.openAlert('', message, 'success');
          setCommitmentModal(!commitmentModal);
          setIsloading(false);
          commitObj && commitObj.getCommitments && commitObj.getCommitments();
          dispatch(dealerInfoAction(parseInt(userId), setIsloading));
        } else if (success === false || success === 'undefined') {
          if (error.length > 0) {
            ModalService.openAlert('', error[0].message, 'error');
          } else {
            if (message === 'Failed to fetch') {
              ModalService.openAlert(
                '',
                'Oops, something went wrong check you internet connection and try again later',
                'error'
              );
            }
          }
        }
        setIsloading(false);
        setIsModalLoading(false);
      }, editpayload);
    }
  };

  // competition insights functionality starts
  const handleAddSegment = (e, key) => {
    setSegmentTurnOver();
    setSegmentName();
    setSegmentYear('');
    setEditSegmentId('');
    setSegmentModal(!segmentModal);
  };

  const handleEditSegment = (val, key) => {
    setSegmentYear(val.year);
    setSegmentName(val.segment);
    setSegmentTurnOver(val.turnover);
    setEditSegmentId(val.id);
    setSegmentModal(!segmentModal);
  };

  const handleSegmentSubmit = (e) => {
    e.preventDefault();
    let payload = {
      user_id: parseInt(userId),
      segment: segmentName,
      year: fYYear.prevFinancialYear,
      turnover: parseInt(segmentTurnOver.toString().replace(/\D/g, '')),
      type: '',
    };
    if (payload.user_id && !editSegmentId) {
      setIsloading(false);
      setIsModalLoading(true);
      addCompetition((res) => {
        const { message, success, error } = res;
        if (success === true) {
          ModalService.openAlert('', message, 'success');
          dispatch(dealerInfoAction(parseInt(userId), setIsloading));
          setIsloading(false);
          setSegmentModal(!segmentModal);
          setSegmentTurnOver();
          setSegmentName();
        } else if (success === false) {
          if (error.length > 0) {
            ModalService.openAlert('', handleErrorMessage(error[0].message), 'error');
          } else {
            if (message === 'Failed to fetch') {
              ModalService.openAlert(
                '',
                'Oops, something went wrong check you internet connection and try again later',
                'error'
              );
            }
          }
        }
        setIsloading(false);
        setIsModalLoading(false);
      }, payload);
    }
    if (editSegmentId) {
      let editPayload = {
        id: editSegmentId,
        segment: segmentName,
        year: segmentYear,
        turnover: parseInt(segmentTurnOver.toString().replace(/\D/g, '')),
        type: '',
      };
      setIsloading(false);
      setIsModalLoading(true);
      editCompetitionInsights((res) => {
        const { message, success, error } = res;
        if (success === true) {
          ModalService.openAlert('', message, 'success');
          dispatch(dealerInfoAction(parseInt(userId), setIsloading));
          setIsloading(false);
          setSegmentModal(!segmentModal);
          setSegmentTurnOver();
          setSegmentName();
        } else if (success === false || success === 'undefined') {
          if (error.length > 0) {
            ModalService.openAlert('', handleErrorMessage(error[0].message), 'error');
          } else {
            if (message === 'Failed to fetch') {
              ModalService.openAlert(
                '',
                'Oops, something went wrong check you internet connection and try again later',
                'error'
              );
            }
          }
        }
        setIsloading(false);
        setIsModalLoading(false);
      }, editPayload);
    }
  };

  const handleAddCompany = (e, key) => {
    setCompanyTurnOver();
    setCompanyName();
    setCompanyYear('');
    setEditCompanyId('');
    setCompanyModal(!companyModal);
  };

  const handleEditCompany = (val, key) => {
    setCompanyName(val.company_name);
    setCompanyYear(val.year);
    setCompanyTurnOver(val.turnover);
    setEditCompanyId(val.id);
    setCompanyModal(!companyModal);
  };

  const handleSubmitCompany = (e) => {
    e.preventDefault();
    let payload = {
      user_id: parseInt(userId),
      company_name: companyName,
      year: fYYear.prevFinancialYear,
      turnover: parseInt(companyTurnOver.toString().replace(/\D/g, '')),
      type: '',
    };
    if (payload.user_id && !editCompanyId) {
      setIsloading(false);
      setIsModalLoading(true);
      addCompetition((res) => {
        const { message, success, error } = res;
        if (success === true) {
          ModalService.openAlert('', message, 'success');
          dispatch(dealerInfoAction(parseInt(userId), setIsloading));
          setIsloading(false);
          setCompanyModal(!companyModal);
        } else if (success === false) {
          if (error.length > 0) {
            ModalService.openAlert('', handleErrorMessage(error[0].message), 'error');
          } else {
            if (message === 'Failed to fetch') {
              ModalService.openAlert(
                '',
                'Oops, something went wrong check you internet connection and try again later',
                'error'
              );
            }
          }
        }
        setIsloading(false);
        setIsModalLoading(false);
      }, payload);
    }
    if (editCompanyId) {
      let editPayload = {
        id: editCompanyId,
        company_name: companyName,
        year: companyYear,
        turnover: parseInt(companyTurnOver.toString().replace(/\D/g, '')),
        type: '',
      };
      setIsloading(false);
      setIsModalLoading(true);
      editCompetitionInsights((res) => {
        const { message, success, error } = res;
        if (success === true) {
          ModalService.openAlert('', message, 'success');
          dispatch(dealerInfoAction(parseInt(userId), setIsloading));
          setIsloading(false);
          setCompanyModal(!companyModal);
        } else if (success === false || success === 'undefined') {
          if (error.length > 0) {
            ModalService.openAlert('', handleErrorMessage(error[0].message), 'error');
          } else {
            if (message === 'Failed to fetch') {
              ModalService.openAlert(
                '',
                'Oops, something went wrong check you internet connection and try again later',
                'error'
              );
            }
          }
        }
        setIsloading(false);
        setIsModalLoading(false);
      }, editPayload);
    }
  };

  const handleFinalSubmit = () => {
    let payload = { user_id: userId };
    swal({
      title: 'Yearly KYC Updation',
      text: 'Are you sure, you want to submit?',
      icon: 'warning',
      buttons: ['No', 'Yes'],
    }).then((isConfirm) => {
      if (isConfirm) {
        setIsloading(false);
        setIsModalLoading(true);
        if (
          commitObj && commitObj.commitmentData && commitObj.commitmentData.length > 0 &&
          segmentData.length > 4 &&
          companyData.length > 2
        ) {
          yearlyKYC((res) => {
            const { success, message, error } = res;
            if (success === true) {
              setIsloading(false);
              ModalService.openAlert('', message, 'success');
              setTimeout(() => {
                navigate(`/list/dealer-list/active`);
              }, 3000);
            } else if (success === false || success === 'undefined') {
              if (error.length > 0) {
                ModalService.openAlert('', handleErrorMessage(error[0].message), 'error');
              } else {
                if (message === 'Failed to fetch') {
                  ModalService.openAlert(
                    '',
                    'Oops, something went wrong check you internet connection and try again later',
                    'error'
                  );
                }
              }
            }
            setIsloading(false);
            setIsModalLoading(false);
          }, payload);
        } else {
          ModalService.openAlert(
            '',
            'Please fill up all input records and atleast three records in Company',
            'error'
          );
          setIsloading(false);
          setIsModalLoading(false);
        }
      }
    });
  };

  return (
    <>
      <AppHeader />
      <div className='app-main'>
        <AppSidebar />
        <div className='app-main__outer'>
          <div className='app-main__inner rms-wrapper'>
            <div id='kycId'>
              {isLoading && <CustomSpinner />}
              <div className='pageWrapper'>
                <Container fluid>
                  <Row>
                    <Col xs={12}>
                      <div className='pageheader'>
                        <DashBoardTitle dashBorardName='YEARLY KYC' />
                        <BreadCrumbBackButton />
                      </div>
                    </Col>
                    <Col xs={12}>
                      <Breadcrumbs title='YEARLY KYC' />
                    </Col>
                  </Row>
                  <div className='mb-3'>
                    <Row>
                      <Col xs={12}>
                        <div className='commitBlock'>
                          <div className='tableArea'>
                            <div className='dealerRegBlocktitle text-center pb-4'>Business Commitment</div>
                            <CommonCommitment
                              userId={userId}
                              commitData={getCommitData}
                              handleEditCommitment={handleEditCommitment}
                            />
                          </div>
                          <AddUserButton onClick={(e) => handleAddCommitment(e, 1)} name="Add Business Commitment" />
                        </div>
                      </Col>
                    </Row>
                  </div>
                  <div className='mb-3'>
                    <Row>
                      <Col xs={12}>
                        <div className='commitBlock insightBlock'>
                          <div className='tableArea'>
                            <div className='dealerRegBlocktitle text-center border-0 pb-4'>Competition Insights</div>
                            <CommonCompetition
                              handleAddSegment={handleAddSegment}
                              handleAddCompany={handleAddCompany}
                              handleEditSegment={handleEditSegment}
                              handleEditCompany={handleEditCompany}
                              totalSegmentTurnOver={totalSegmentTurnOver}
                              totalCompanyTurnOver={totalCompanyTurnOver}
                              segmentData={segmentData}
                              companyData={companyData}
                            />
                          </div>
                        </div>
                      </Col>
                    </Row>
                  </div>
                  <Row>
                    <Col xs={12}>
                      <div className='common-buttons d-flex flex-wrap align-items-center justify-content-center'>
                        <CommonButton name={'Submit'} btnClass={'btnPrimary'} type="button" onClick={handleFinalSubmit} disabled={!isBtnDisabled} />
                      </div>
                    </Col>
                  </Row>
                </Container>
              </div>

              {/* commitment modal for add/edit */}
              <CommitmentModal
                isModalLoading={isModalLoading}
                isOpen={commitmentModal}
                toggle={() => setCommitmentModal(!commitmentModal)}
                editCommitmentId={editCommitmentId}
                productId={productId}
                product={product}
                commitment={commitment}
                secondYearcommitment={secondYearcommitment}
                thirdYearcommitment={thirdYearcommitment}
                productUnit={productUnit}
                handleProduct={handleProduct}
                handleSubmitCommmitment={handleSubmitCommmitment}
              />

              {/* Input wise Segment - competition insights modals */}
              <SegmentModal
                isModalLoading={isModalLoading}
                isOpen={segmentModal}
                toggle={() => setSegmentModal(!segmentModal)}
                editSegmentId={editSegmentId}
                handleSegmentSubmit={handleSegmentSubmit}
                segmentName={segmentName}
                setSegmentName={setSegmentName}
                segmentYear={segmentYear}
                segmentTurnOver={segmentTurnOver}
                setSegmentTurnOver={setSegmentTurnOver}
              />

              {/* Company wise - competition insights modals */}
              <CompanyModal
                isModalLoading={isModalLoading}
                isOpen={companyModal}
                toggle={() => setCompanyModal(!companyModal)}
                editCompanyId={editCompanyId}
                handleSubmitCompany={handleSubmitCompany}
                companyName={companyName}
                setCompanyName={setCompanyName}
                companyYear={companyYear}
                companyTurnOver={companyTurnOver}
                setCompanyTurnOver={setCompanyTurnOver}
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default KYC;
